import { isAndroid, isTizen } from './Platform';

import { AudioSoundManagerModule } from '../components/android/AudioSoundManager/AudioSoundManager';

export const getDeviceVolume = async () => {
  if (isTizen) {
    const mute = window.tizen?.tvaudiocontrol?.isMute();

    return mute ? 0 : window.tizen?.tvaudiocontrol?.getVolume();
  } else if (isAndroid) {
    return await AudioSoundManagerModule?.getSystemSoundSetting();
  } else {
    return null;
  }
};
